module.exports = __webpack_public_path__ + "static/festival-homes-logo-white-7b04d1898f9fd8fe4531cf8bce5d0e35.svg";